import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
// import './index.css';
import './App.css';
// import '/App.js';
import App from './App';
import reportWebVitals from './reportWebVitals';
// import CaraAdminLoginPage from './components/CaraAdminLoginPage';
import { AuthProvider } from './contexts/AuthContext';
import { PermissionProvider } from './contexts/PermissionContext';
import './i18n';

import { attachCsrfInterceptor } from './utils/csrf';

// Set global axios defaults for session persistence
axios.defaults.withCredentials = true;
attachCsrfInterceptor(axios);

// Disable verbose console logging in production (F08: these leaked full API
// response data). console.warn/console.error are left alone so real runtime
// errors are still visible in production for debugging/support.
if (process.env.NODE_ENV === 'production') {
    console.log = () => {};
    console.debug = () => {};
    console.info = () => {};
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <AuthProvider>
        <PermissionProvider>
            <App />
            {/* <CaraAdminLoginPage/> */}
        </PermissionProvider>
    </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
